"use client";

import React from "react";
import HeroCardBadges from "./HeroCardBadges";
import { LOCALE_COOKIE_NAME } from "@/lib/locale/constants";
import Cookies from "js-cookie";
import { cn } from "@/lib/utils";
import resolveCountryName from "./utils/resolveCountryName";
import type { ProgramPricingData } from "@/lib/ecommerce/commercetools/client-only/getProgramPricingData";
import type { GeoPricingLocation } from "./types";

type ActionCardWrapperProps = {
  pricingData?: Partial<ProgramPricingData> | null;
  children: React.ReactNode;
  className?: string;
  badgesPlacement?: "start" | "end" | null;
  location: GeoPricingLocation;
};

export default function ActionCardWrapper({
  pricingData,
  children,
  className,
  badgesPlacement = null,
  location,
}: ActionCardWrapperProps) {
  const isEnabled = pricingData?.geoPricing !== undefined;
  const locale = Cookies.get(LOCALE_COOKIE_NAME) ?? "en";
  const checkoutGeoPricing = pricingData?.checkoutGeoPricingEligibility;

  if (!isEnabled || !pricingData?.checkoutGeoPricingEligibility?.eligible) {
    return <div className={className}>{children}</div>;
  }

  const countryCode = checkoutGeoPricing?.countryCode ?? "";
  const countryName = resolveCountryName(countryCode, locale);
  const percentageDiscount = checkoutGeoPricing?.discountPercentage ?? 0;
  const heroCardBadges = pricingData?.geoPricing?.heroCardBadges;
  const badgeText = heroCardBadges?.badgeText;
  const placement = badgesPlacement ?? heroCardBadges?.placement ?? "start";
  const showHeroBadges =
    heroCardBadges != null && badgeText != null && badgeText !== "";

  return (
    <div
      className={cn(
        "geo-action-card-wrapper flex flex-col items-center gap-2",
        className,
        placement === "end" ? "flex-col-reverse" : "",
      )}
    >
      {showHeroBadges && (
        <HeroCardBadges
          percentageDiscount={percentageDiscount}
          countryName={countryName}
          badgeText={badgeText}
          badgeIcon={heroCardBadges.badgeIcon}
          subBadgeText={heroCardBadges.subBadgeText}
          location={location}
        />
      )}

      <div className="flex flex-col gap-4">{children}</div>
    </div>
  );
}
